import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { throwError, pipe, Observable } from "rxjs";
import { retry, catchError } from "rxjs/operators";
import { Klinik } from "../randevu-ver/klinik";
import { Klinikrandevu } from "../randevu-ver/klinikrandevu";
import { Odabilgisi } from "../randevu-ver/odabilgisi";
import { TarihListesi } from '../randevu-ver/tarih-listesi';
import { Serviscevap } from '../models/serviscevap';
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class KlinikService {
  env = environment;
  base_path = this.env.uzakrandevuUrl + "klinik/";

  constructor(private httpClient: HttpClient) {}

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error("Bir hata oluştu:", error.error.message);
    } else {
      console.error(
        `Servisten dönen kod ${error.status}, ` + `çerçeve: ${error.error}`
      );
    }
    return throwError("Bilinmeyen bir hata oluştu; lütfen daha sonra tekrar deneyiniz.");
  }

  getKlinik(): Observable<Klinik[]> {
    return this.httpClient.get<Klinik[]>(this.base_path + "kliniklistesi", this.httpOptions);
  }

  getRandevuSablon(klinik): Observable<Klinikrandevu[]> {
    return this.httpClient
      .post<Klinikrandevu[]>(
        this.base_path + "klinikRandevuListesi",
        klinik,
        this.httpOptions
      )
      .pipe(retry(2), catchError(this.handleError));
  }

  getOdaBilgisi(klinik): Observable<Odabilgisi[]> {
    return this.httpClient
      .post<Odabilgisi[]>(this.base_path + "klinikOdaListesi", klinik, this.httpOptions)
      .pipe(retry(2), catchError(this.handleError));
  }

  getTarihListesi(item):Observable<TarihListesi[]>{
    return this.httpClient
    .post<TarihListesi[]>(this.base_path + "tarihlistesi", item, this.httpOptions)
    .pipe(retry(2), catchError(this.handleError));
  }

  randevuKayit(item):Observable<Serviscevap[]> {
    return this.httpClient
      .post<Serviscevap[]>(this.base_path + "randevukayit", item, this.httpOptions)
      .pipe(retry(2), catchError(this.handleError));
  }
}
